import { mount } from 'mount-vue-component';
import DLoadingOverlay from './DLoadingOverlay.vue';
import { registerComponents, vueUse, registerComponentProgrammatic } from '../../../utils/plugins';

const components = {
  DLoadingOverlay,
};

const LoadingProgrammatic = (app) => {
  function open(params) {
    const defaultParam = {
      programmatic: true,
    };
    const propsData = Object.assign(defaultParam, params);
    return mount(DLoadingOverlay, {
      props: propsData,
      app,
    });
  }

  return { open };
};

const Registered = {
  install(Vue) {
    registerComponents(Vue, components);
    registerComponentProgrammatic(Vue, '$loadingOverlay', LoadingProgrammatic(Vue));
  },
};

vueUse(Registered);

export default Registered;